import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "section",
    "toggleButton",
    "toggleLabel",
    "chevron",
    "password",
    "passwordRequiredBadge",
    "passwordConfirmation",
    "currentPassword",
    "passwordConfirmationRequiredBadge",
    "currentPasswordRequiredBadge"
  ]

  connect() {
    if (this.passwordFieldsFilled()) {
      this.openSection()
    } else {
      this.closeSection()
    }

    this.sync()
  }

  toggle() {
    if (this.sectionTarget.classList.contains("hidden")) {
      this.openSection()
    } else {
      this.clearPasswordFields()
      this.closeSection()
    }

    this.sync()
  }

  sync() {
    const passwordChangeRequested = this.passwordFieldsFilled()

    this.passwordTarget.required = passwordChangeRequested
    this.passwordConfirmationTarget.required = passwordChangeRequested
    this.currentPasswordTarget.required = passwordChangeRequested

    this.passwordRequiredBadgeTarget.classList.toggle("hidden", !passwordChangeRequested)
    this.passwordConfirmationRequiredBadgeTarget.classList.toggle("hidden", !passwordChangeRequested)
    this.currentPasswordRequiredBadgeTarget.classList.toggle("hidden", !passwordChangeRequested)

    if (!this.passwordFieldsFilled() && !this.sectionTarget.classList.contains("hidden")) {
      this.toggleLabelTarget.textContent = "パスワード変更をやめる"
      this.chevronTarget.classList.add("rotate-180")
      return
    }

    if (this.sectionTarget.classList.contains("hidden")) {
      this.toggleLabelTarget.textContent = "パスワードを変更"
      this.chevronTarget.classList.remove("rotate-180")
    } else {
      this.toggleLabelTarget.textContent = "パスワード変更をやめる"
      this.chevronTarget.classList.add("rotate-180")
    }
  }

  passwordFieldsFilled() {
    return [
      this.passwordTarget,
      this.passwordConfirmationTarget,
      this.currentPasswordTarget
    ].some((field) => field.value.trim().length > 0)
  }

  openSection() {
    this.sectionTarget.classList.remove("hidden")
    this.toggleButtonTarget.setAttribute("aria-expanded", "true")
  }

  closeSection() {
    this.sectionTarget.classList.add("hidden")
    this.toggleButtonTarget.setAttribute("aria-expanded", "false")
  }

  clearPasswordFields() {
    this.passwordTarget.value = ""
    this.passwordConfirmationTarget.value = ""
    this.currentPasswordTarget.value = ""
  }
}
